import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchCountriesShipping } from '../../../services/countries';
import { getCountriesShippingKey } from '../query-keys';
import { IncomingMessage } from 'http';

const getCountriesShipping = (
  options: {
    locale: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchCountriesShipping>
] => [
  getCountriesShippingKey(options),
  ({
    queryKey: [, locale],
  }: {
    queryKey: string[];
  }): Promise<Record<string, TCountryShipping>> =>
    fetchCountriesShipping({ locale }, req),
];

export default getCountriesShipping;
